import React, { useState, useEffect } from "react";
import { Popover, Tooltip } from "bootstrap";
import QuestionSolution from "../../../../components/QuestionSolution";
import MathElement from "../../../../components/MathElements";

const ViewOnly = (props) => {
    
    const [question] = useState(props.question ?? '')
    const [checkAnswerClass, setCheckAnswerClass] = useState(false)
    const [serialNo] = useState(props.serialNo ?? 0)
    const [progressData] = useState(props.progressData ?? {})
    const [progressText, setProgressText] = useState(props.progressText ?? '')

    const saveAnswer = () => {
        let is_correct = true
        let answer = {saveAnswer: ''}
          
        if(props.mode !== 'review'){
            let index = progressData.value === is_correct ? progressData.index + 1 : 0
            let progress_text = is_correct ? (progressData.correctText[index] ?? progressData.correctText[0]) : (progressData.incorrectText[index] ?? progressData.incorrectText[0])
            let question_time = localStorage.getItem('question_counter');
            let submitAnswerInfo = {question_id: question.id, question: question.question, correct: is_correct, order: question.order, question_type: question.question_type, progress_text: progress_text, time: question_time}
            setProgressText(progress_text)
            props.setPrevQuestionDetails((prev) => ([...prev, submitAnswerInfo]))
            props.setPrevAnswerDetails((prev) => ([...prev, answer]))
            props.saveAnswer(submitAnswerInfo, answer)
        }
        return is_correct;
    }

    const submitAnswer = () => {
        saveAnswer()
        props.setActiveQuestion((prev) => prev+1)
    }

    useEffect(() => {
        setCheckAnswerClass('right');
        Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(popoverNode => new Popover(popoverNode));
        Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach(tooltipNode => new Tooltip(tooltipNode));
    },[])


    return (
        <>
            <div className={`fs-18 question border border-3 p-3 rounded-4 mb-4 ${checkAnswerClass === 'right' ? 'border-green' : checkAnswerClass ? 'border-danger' : 'border-blue'}`}>
                <h6 className={`fs-18 fw-bold pb-2 pt-2 ${checkAnswerClass === 'right' ? 'text-green' : checkAnswerClass ? 'text-danger' : 'text-blue'}`}>
                    Question {serialNo}
                    <span>
                        <button type="button" className="btn ms-2 p-0 border-0" data-bs-content="&nbsp;" data-bs-toggle="popover" data-bs-trigger="focus hover" data-bs-template="<div class=&quot;popover shadow&quot; role=&quot;popover&quot;><div class=&quot;popover-arrow&quot;></div><div class=&quot;popover-inner pt-3 px-3&quot;>Click to select one of the carded options as the correct response. You may only select one response.<div class=&quot;row px-3 my-3 &quot;><div class=&quot;col-sm-12 &quot;><div class='d-flex gap-2'><div><img src='/images/ex-select.png'class='img-fluid'></img></div></div></div></div>"><svg className="icon ts-1p5"><use href="#icon_query"></use></svg></button>
                    </span>
                </h6>

                <span className="raw-question"><MathElement ele_id={`question_${question.order}_div`} elements={question.question}/></span>

                <div className="col-12 mt-4"></div>

                <div className="button d-flex justify-content-between mt-4">
                    {checkAnswerClass && question && question.solution_image && <button className="btn btn-outline-default btn-lg minw-90 m-2 ms-0" data-bs-target="#solutionModal" data-bs-toggle="modal">Solution</button>}
                    {checkAnswerClass && <span className={`fw-bold mt-3 fs-5 me-2 ${checkAnswerClass === 'right' ? 'text-green' : 'text-danger'}`}>{progressText}</span>}
                    {(checkAnswerClass) &&  <button id={`${question.order}_submit_answer`} className={`btn btn-lg m-2 ms-auto me-0 ${props.mode === 'exam' && 'btn-theme-primary disabled'} ${checkAnswerClass === 'right' ? 'btn-green' : checkAnswerClass ? 'btn-danger' : 'border-blue'}`} onClick={() => submitAnswer()}>Next</button>}
                </div>
            </div>
            {question.solution_image && <QuestionSolution image={question.solution_image} />}
        </>
    )
}
export default ViewOnly;
